<template>
  <div class="main-container">
    <div class="page-top-title">
      <p class="title">{{ reportName }}</p>
      <div class="page-top-right">
        <div class="item">
          结算周期：
          <span class="num">{{ settlementDate }}</span>
        </div>
        <div class="item settlement-status">
          结算状态：
          <div v-if="detailData.settlementStatus == 0" class="tag-settled">未结算</div>
          <div v-else class="tag-be">已结算</div>
        </div>
      </div>
    </div>
    <div class="statistics-container">
      <p>汇总数据</p>
      <div class="statistics-item">
        <div class="item">
          保单数：
          <span class="num">{{ statisticsObj.policyNum || 0 }}</span>
          单
        </div>
        <div class="item">
          批单数：
          <span class="num">{{ statisticsObj.billNum || 0 }}</span
          >单
        </div>
        <div class="item">
          保费：
          <span class="num">{{ statisticsObj.sumFee || 0 }}</span
          >元
        </div>
        <div class="item">
          净收入：
          <span class="num">{{ statisticsObj.sumNetIncome || 0 }}</span
          >元
        </div>
      </div>
    </div>

    <loading :isShow="listLoading" />
    <div class="table-box">
      <Table ref="table" :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="detailsPage(row)">明细</span>
        </template>
      </Table>
    </div>
    <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />

    <div>
      <Button class="btn" @click="back('/orgSettlement/groupCommissionSettlement')">返回</Button>
      <Button class="btn" @click="backOperate" v-if="detailData.settlementStatus == 0">上一步</Button>
      <Button class="btn" @click="settledStep" v-if="detailData.settlementStatus == 1">上一步</Button>
      <Button class="btn" @click="exportReport">导出报表</Button>
      <Button type="primary" class="btn" @click="settlement" v-if="detailData.settlementStatus == 0">结算</Button>
      <Button type="primary" class="btn" v-else @click="resettlement">撤回结算</Button>

      <Button type="primary" class="btn" v-show="detailData.settlementStatus == 1 && detailData.payStatus == 0" @click="payment">付款</Button>
      <Button type="primary" class="btn" v-show="detailData.settlementStatus == 1 && detailData.payStatus == 1" @click="payment">取消付款</Button>
      <Button type="primary" :disabled="detailData.settlementStatus == 0 ? true : false" v-if="detailData.settlementStatus == 0">付款</Button>
    </div>

    <payPopUp ref="payPopUpRef" @change-pay="getDetailData"></payPopUp>
  </div>
</template>

<script>
import { common, pageTool } from '@/api/mixins';
import payPopUp from '../components/payPopUp';
export default {
  mixins: [common, pageTool],
  components: { payPopUp },
  props: {
    backData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      reportId: null,
      settlementStatus: null,
      step: null,
      reportName: '',
      settlementDate: '',
      statisticsObj: {},
      detailData: {},
      tableData: [],
      total: 0,
      columns: [
        {
          title: '机构',
          align: 'center',
          key: 'orgName',
          minWidth: 200
        },
        {
          title: '保单数',
          align: 'center',
          key: 'policyNum',
          minWidth: 120
        },
        {
          title: '批单数',
          align: 'center',
          key: 'billNum',
          minWidth: 120
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '净收入',
          align: 'center',
          key: 'income',
          minWidth: 100
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 80,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    const { reportId, settlementDate, reportName, step } = this.$route.query;
    this.reportId = reportId;
    this.reportName = reportName;
    this.settlementDate = settlementDate;
    this.step = step;
  },
  activated() {
    if (this.reportId) {
      this.pageNum = 1;
      this.getList();
      this.getStatisticsData();
      this.getDetailData();
    }
  },
  methods: {
    setData() {
      const { reportId, settlementDate, reportName } = this.backData;
      this.reportId = reportId;
      this.reportName = reportName;
      this.settlementDate = settlementDate;
      this.pageNum = 1;
      this.getList();
      this.getStatisticsData();
      this.getDetailData();
    },

    // 获取详情
    getDetailData() {
      this.$http({
        url: '/buz/settlementReport/read/detail',
        type: 'GET',
        data: {
          id: this.reportId
        }
      }).then(res => {
        this.detailData = res.data;
      });
    },

    // 统计
    getStatisticsData() {
      this.$http({
        url: '/buz/settlementData/statistics',
        type: 'POST',
        data: {
          reportId: this.reportId
        }
      }).then(res => {
        if (res.data) {
          this.statisticsObj = res.data;
        }
      });
    },

    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/settlementDetails/read/page',
        type: 'POST',
        data: {
          reportId: this.reportId,
          pageNo: this.pageNum,
          pageSize: this.pageSize
        }
      })
        .then(res => {
          this.tableData = res.data;
          this.total = res.total;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    // 明细
    detailsPage(row) {
      this.openPageTabTags('/orgSettlement/groupCommissionSettlement/detail', {
        reportId: this.reportId,
        orgId: row.orgId,
        title: `${row.orgCode}/${row.orgName}${this.settlementDate}基础费用结算明细`
      });
    },

    // 上一步
    backOperate() {
      if (!this.$units.pointAction('offline_82_3_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$http({
        url: '/buz/settlementDetails/rollback',
        type: 'POST',
        data: {
          reportId: this.reportId
        }
      }).then(res => {
        this.$emit('backPage', { reportId: this.reportId, isAdd: 0, settled: false });
      });
    },

    // 已结算上一步
    settledStep() {
      this.$emit('settledStep', { reportId: this.reportId, isAdd: 0, settled: true });
    },

    // 导出
    exportReport() {
      if (!this.$units.pointAction('offline_82_3_4')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$units.downloadFile('/buz/settlementDetails/export', { reportId: this.reportId }, 'POST');
    },

    // 结算
    settlement() {
      if (!this.$units.pointAction('offline_82_3_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$notice.inquiry('结算后下级机构即可登录查看已结算清单，请确认是否结算?').then(() => {
        this.$http({
          url: '/buz/settlementReport/settlement',
          type: 'POST',
          data: {
            id: this.reportId
          }
        }).then(res => {
          this.getList();
          this.getDetailData();
          this.$notice.success('结算成功');
        });
      });
    },

    // 撤回结算
    resettlement() {
      if (!this.$units.pointAction('offline_82_3_1')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$notice.inquiry('您确定撤回结算吗?').then(() => {
        this.$http({
          url: '/buz/settlementReport/resettlement',
          type: 'POST',
          data: {
            id: this.reportId
          }
        }).then(res => {
          this.getList();
          this.getDetailData();
          this.$notice.success('撤回成功');
        });
      });
    },

    // 付款/取消付款
    payment() {
      if (!this.$units.pointAction('offline_82_3_6')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      this.$refs.payPopUpRef.open(this.detailData.payStatus, this.reportId);
    }
  }
};
</script>

<style lang="scss" scoped>
.page-top-title {
  font-size: 15px;
  display: flex;
  .title {
    font-size: 16px;
    color: #3c464f;
    font-weight: bold;
  }
  .page-top-right {
    display: flex;
    align-items: center;
    margin-left: auto;
    .item {
      color: #515c6f;
      font-size: 14px;
      margin-left: 20px;
    }
    .settlement-status {
      margin-top: 1px;
      margin-left: 20px;
      display: flex;
      .tag-settled {
        width: 55px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border-radius: 2px;
        font-size: 13px;
        color: #e3461f;
        border: 1px solid #ffc1b2;
        background: #fff5f2;
      }
      .tag-be {
        width: 55px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border-radius: 4px;
        font-size: 13px;
        color: #35bf3f;
        border: 1px solid #abeaae;
        background: #f6fcf4;
      }
    }
  }
}
.statistics-container {
  margin-top: 20px;
  display: flex;
  p {
    white-space: nowrap;
  }
  .statistics-item {
    margin-left: 20px;
    display: flex;
    flex-wrap: wrap;
    color: #333;

    .item {
      font-weight: bold;
      white-space: nowrap;
      margin-bottom: 10px;
      width: 300px;
      .num {
        color: #ff7134;
      }

      .label {
        position: relative;

        .tip-icon {
          margin-right: 2px;
          width: 15px;
          height: 15px;
          border-radius: 15px;
          background: transparent;
          border: 1px solid #9c9c9c;
          color: #a8a6a6;
          display: inline-block;
          text-align: center;
          line-height: 14px;
          font-size: 14px;
          cursor: pointer;
          top: 50%;
        }

        .tip-icon:hover + .pop-tip {
          opacity: 0.9;
          z-index: 9999;
          display: block;
        }

        .pop-tip {
          position: absolute;
          width: 250px;
          top: -42px;
          display: flex;
          align-items: center;
          text-align: left;
          left: 50%;
          margin-left: -90px;
          padding: 6px 10px;
          display: flex;
          flex-direction: column;
          background-color: #444444;
          display: none;
          border-radius: 4px;

          span {
            font-size: 12px;
            font-weight: 500;
            color: #fff;
          }

          .arrow {
            position: absolute;
            width: 12px;
            height: 12px;
            background-color: #444444;
            opacity: 0.9;
            bottom: -4px;
            left: 74px;
            transform: rotateZ(135deg);
          }
        }
      }
    }
  }
}
</style>
